import { render, staticRenderFns } from "./KefuFloat.vue?vue&type=template&id=7af8d3ba&scoped=true"
import script from "./KefuFloat.vue?vue&type=script&lang=js"
export * from "./KefuFloat.vue?vue&type=script&lang=js"
import style0 from "./KefuFloat.vue?vue&type=style&index=0&id=7af8d3ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af8d3ba",
  null
  
)

export default component.exports